<template>
    <v-text-field
            :label="name"
            :hint="description"
            persistent-hint
            :required="Boolean(isRequired)"
            :rules="Boolean(isRequired) ? [ rules.required, rules.email ] : [ rules.email ]"
            :value="currentValue" @input="onInput"
    />
</template>

<script>

import formComponent from '../mixins/form_component'
import defaultParser from '../parsers/input_parser'

export default {

  name: 'FormEmail',

  mixins: [ formComponent ],

  /**
   *
   *
   */
  props: {

  },

  /**
   *
   *
   */
  created() {

  },

  /**
   *
   *
   */
  data() {

    return {

      // Описание поля
      description: '',

      // Обязательное поле
      isRequired: false,

      // rules: {
      //
      //   required: (value) => !!value || 'Обязательно для заполнения.',
      //
      //   email: (value) => {
      //     const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //     return value ? (pattern.test(value) || 'Неверный формат электронного адреса.') : true
      //   }
      // },

      // Правила валидации
      rules: {

        required: this.validator( this.required, 'Необходимо заполнить поле' ),

        email: ( value ) => {
          const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return value ? ( pattern.test( value ) || 'Неверный формат электронного адреса' ) : true
        }
      }
    }
  },

  /**
   *
   *
   */
  watch: {

  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     * Инициализация компонента.
     *
     *  - подключение парсера
     *  - инициализация данных и значения по умолчанию
     *
     */
    init() {

      // Инициализация парсера.
      this.initParser( defaultParser )

      this.name = this.parser.getName( this.data )
      this.description = this.parser.getDescription( this.data )
      this.isRequired = this.parser.getRequired( this.data )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/form/FormEmail.vue